import React from 'react';
import ReactDOM from 'react-dom';

interface ModalPortalProps {
  children: React.ReactNode;
}

export const ModalPortal: React.FC<ModalPortalProps> = ({ children }) => {
  return ReactDOM.createPortal(
    <div style={{ position: 'fixed', inset: 0, zIndex: 200 }}>{children}</div>,
    document.body,
  );
};
